import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  noLocationSet: {
    id: 'app.shared.components.header.noLocationSet',
    description: 'Indicating that no location is set',
    defaultMessage: 'No location set',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/shared/i18n.js